// extracted by mini-css-extract-plugin
export default {"content":"TarotReadingResultPage_content__JJH0P"};